<!-- Adapted from SPlayer 40d9ec6 Discover/artists.vue and List/ArtistList.vue (AGPL-3.0). -->
<template>
  <div class="discover-artists" :aria-busy="loading">
    <div class="menu"><span>热门歌手</span></div>
    <div class="artist-list"><div class="artist-grid">
      <router-link v-for="item in items" :key="item.id" class="artist-item" :to="{ name: 'artist', params: { id: String(item.id) } }">
        <div class="cover"><img class="cover-img" :src="item.img1v1Url || item.picUrl || fallback" alt="" loading="lazy" @error="fallbackImage" /></div>
        <div class="cover-data"><span class="name">{{ item.name }}</span><span v-if="item.musicSize" class="num">{{ item.musicSize }} 首歌曲</span></div>
      </router-link>
    </div></div>
    <FeedStatus :loading="loading" :error="error" :count="items.length" empty-text="来源暂未返回热门歌手。" @retry="loadFeed(false)" />
  </div>
</template>
<script>
import { runtime } from '../../bridge';
import catalogFeed from './catalog-feed';
import FeedStatus from './FeedStatus.vue';
export default {
  name: 'SPlayerDiscoverArtists', mixins: [catalogFeed], components: { FeedStatus },
  data() { return { catalogSettings: runtime.catalogSettings, fallback: runtime.cover() }; },
  computed: { platform() { return this.catalogSettings.platform; }, feedKey() { return this.platform; } },
  methods: {
    async fetchFeed() {
      const data = await runtime.catalog(this.platform === 'tx' ? 'artists' : 'home', undefined, { platform: this.platform, limit: 50 });
      // NetEase's current home service provides six genuine popular artists.
      // No local alphabetical filter is presented as a complete remote directory.
      if (this.platform === 'wy' && !data.artists?.length && data.diagnostics?.some(item => item.id === 'artists' && !item.ok)) throw new Error('热门歌手加载失败，请重试。');
      return { items: data.artists, more: false };
    },
    fallbackImage(event) { if (event.target.src !== this.fallback) event.target.src = this.fallback; },
  },
};
</script>
<style scoped>
.menu { display:flex; align-items:center; min-height:40px; font-size:14px; font-weight:500; }
.artist-list { width: 100%; padding: 12px 0; }
.artist-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 8px 16px; }
.artist-item { display:flex; align-items:center; min-width:0; padding:12px 16px; gap:12px; border-radius:6px; color:inherit; text-decoration:none; }
.artist-item:hover { background: var(--salt-hover, #8881); }
.cover { width: 52px; height: 52px; border-radius: 50%; flex-shrink: 0; overflow: hidden; }
.cover-img { width: 100%; height: 100%; object-fit: cover; }
.cover-data { display:flex; flex-direction:column; gap:2px; min-width:0; }
.name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 14px; }
.num { font-size: 12px; color: var(--salt-subtext, var(--color-secondary)); }
@container (max-width: 440px) { .artist-grid { grid-template-columns: minmax(0, 1fr); } }
</style>
